import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
//import BtnOffcanvas from '../../../Components/btn/btnOffcanvas';
import HeaderBase from './headerBase';
import DropDownDark from '../../../Components/dropdown/dropdownDark';
import { AppConfigContext } from '../../../Config/App';
import { LanguageContext } from '../../../Data/Context/languageContext';
import dropDownList from '../../../Components/dropdown/languages.json';
import Ads from '../../../Components/ads';

const DashboardHeader = (props) => {
    const { navigate_to } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);

    return (
        <>
            <HeaderBase>
                <div className="col d-flex justify-content-center justify-content-sm-end order-1 order-sm-2 pe-0">
                    {/* <BtnOffcanvas classes="btn-primary me-2 d-lg-none" offcanvas="offcanvas-search-1" text="Search Builds" icon="fa-solid fa-magnifying-glass"></BtnOffcanvas> */}

                    <div className='d-none d-lg-block me-3'>
                        <DropDownDark classes="dropdown dropstart" changeLanguage={true} buttonText="English" dropDownList={dropDownList} />
                    </div>

                    <Link className='btn btn-success d-none d-sm-block' to={navigate_to('new-build')}>
                        {t("create_build")}<i className='fa-solid fa-plus'></i>
                    </Link>
                </div>

                <div className='col-12 p-0 order-2 mt-3'>
                    <Ads classes="container text-center" slot="9408614093" />
                </div>

                <div className="col-12 col-sm-5 col-xl-4 col-xxl-3 text-center order-2 order-sm-1 mt-sm-1">
                    <Link className='btn btn-success header-btn my-3 d-block d-sm-none' to={navigate_to('new-build')}>
                        {t("create_build")} <i className='fa-solid fa-plus'></i>
                    </Link>

                    <h1 className="mb-0 site-title box">{t("user_dashboard")}</h1>
                </div>
            </HeaderBase>
        </>
    );
}
export default DashboardHeader;